const BASE_URL = 'https://m2.mtmt.hu/api';

interface ApiResponse<T> {
  ok: boolean;
  data: T | null;
}

export default {
  authorSuggestions: async (input: string): Promise<ApiResponse<any>> => {
    try {
      const response = await fetch(
        `${BASE_URL}/author?size=200&depth=0&cond=label;any;${encodeURIComponent(input)}&sort=familyName,asc&sort=givenName,asc&labelLang=hun&format=json`
      );
      if (!response.ok) return { ok: false, data: null };
      return { ok: true, data: await response.json() };
    } catch (error) {
      console.error('Error in authorSuggestions:', error);
      return { ok: false, data: null };
    }
  },

  author: async (id: string): Promise<ApiResponse<any>> => {
    try {
      const response = await fetch(
        `${BASE_URL}/author/${id}?format=json`
      );
      if (!response.ok) return { ok: false, data: null };
      return { ok: true, data: await response.json() };
    } catch (error) {
      console.error('Error in author:', error);
      return { ok: false, data: null };
    }
  },

  publications: async (id: string): Promise<ApiResponse<any>> => {
    try {
      const response = await fetch(
        `${BASE_URL}/publication?cite_type=2&size=5000&cond=published;eq;true&cond=core;eq;true&cond=authors;in;${id}&fields=citations,journal:1&sort=publishedYear,desc&format=json`
      );
      if (!response.ok) return { ok: false, data: null };
      return { ok: true, data: await response.json() };
    } catch (error) {
      console.error('Error in publications:', error);
      return { ok: false, data: null };
    }
  },

  getObjectByLink: async (link: string): Promise<ApiResponse<any>> => {
    try {
      const response = await fetch(`https://m2.mtmt.hu/${link}?format=json`);
      if (!response.ok) return { ok: false, data: null };
      return { ok: true, data: await response.json() };
    } catch (error) {
      console.error('Error in getObjectByLink:', error);
      return { ok: false, data: null };
    }
  },
};


